import { render } from "./NavigationTemplate.vue?vue&type=template&id=44f8b5ac"
import script from "./NavigationTemplate.vue?vue&type=script&lang=js"
export * from "./NavigationTemplate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__